import { render, staticRenderFns } from "./DatatableSelectToMessage.vue?vue&type=template&id=ba6960ba&scoped=true&"
import script from "./DatatableSelectToMessage.vue?vue&type=script&lang=js&"
export * from "./DatatableSelectToMessage.vue?vue&type=script&lang=js&"
import style0 from "./DatatableSelectToMessage.vue?vue&type=style&index=0&id=ba6960ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6960ba",
  null
  
)

export default component.exports